<template>
  <v-row>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  Payslip Sender
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <v-btn
                  color="primary"
                  class="ml-auto"
                  :disabled="table.data.length <= 0"
                >
                  <download-csv :data="exportData" :name="`${fileName}.csv`">
                    <v-icon dense>mdi-download</v-icon>
                    Export
                  </download-csv>
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-row>
            <v-col cols="10">
              <v-file-input
                counter
                show-size
                small-chips
                truncate-length="50"
                accept=".csv"
                label="Upload CSV"
                @change="selectFile"
              ></v-file-input>
            </v-col>
            <v-col cols="2" class="mt-3">
              <v-btn color="primary" block dark @click="upload">
                Upload
                <v-icon right dark>mdi-file-delimited</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <!-- <v-file-input
            counter
            show-size
            small-chips
            truncate-length="50"
            accept=".csv"
            label="Upload CSV"
          ></v-file-input> -->
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :items-per-page="10"
          :loading="table.loading"
          item-key="id"
          :search="search"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template
            v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:[`item.configured`]="{ item }">
            {{ item.configured ? "Yes" : "No" }}
          </template>

          <template v-slot:[`item.referenceNumber`]="{ item }">
            <a href="#" @click.prevent="searchOlt(item)">{{
              item.referenceNumber
            }}</a>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <OnuList ref="onuList" />
  </v-row>
</template>

<script>
// import moment from "moment";
import OnuList from "../dialogs/management/OnuList.vue";
// import _ from "lodash";

export default {
  name: "CheckOLT",
  components: {
    OnuList,
  },

  data() {
    return {
      exportData: [],
      fileName: "",

      currentFile: undefined,
      content: [],
      parsed: false,

      search: "",
      olt: "",
      table: {
        expanded: [],
        singleExpand: false,
        // sortBy: "dtCreated",
        sortDesc: true, 
        loading: false,
        headers: [
          {
            text: "NAP Code",
            sortable: false,
            value: "napCode",
          },
          {
            text: "Configured",
            align: "center",
            value: "configured",
          },
          { text: "OLT Name", sortable: false, value: "oltName" },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    selectFile(file) {
      // this.progress = 0;
      this.currentFile = file;
    },

    async checkOlt(arrNap) {
      this.table.loading = true;
      await this.$api
        .post("/ibas-check-olt", { napCodes: arrNap })
        .then((response) => {
          console.log(response);
          const newArr = response.data.data;
          // console.log(newArr);
          this.table.data = newArr.napCodes;

          let exportData = newArr.napCodes.map((item) => {
            return {
              // "Payment Date": moment(item.paymentDate).format("MM/DD/YYYY"),
              "NAP Code": item.napCode,
              Configured: item.configured ? "Yes" : "No",
              "OLT Name": item.oltName,
            };
          });

          this.fileName = "nap_codes";
          this.exportData = exportData;

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    upload() {
      this.$papa.parse(this.currentFile, {
        skipEmptyLines: true,
        header: true,
        complete: (results) => {
          let napArray = results.data.map((item) => {
            return item["NAP Code"];
          });

          this.checkOlt(napArray);
          // console.log(napArray);
        },
      });

      // console.log(ad);
    },

    searchOlt() {
      this.checkOlt([this.olt]);
    },
  },
  created() {
    // this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
